import {
    ORDERS_REQUEST,
    ORDERS_SUCCESS,
    ORDERS_FAIL,
    SHOW_ORDER_POPUP,
    DUPLICATE_ORDER_POPUP,
    HIDE_ORDER_POPUP,
    SHOW_EXPIRED_ORDERS_POPUP,
    SHOW_COMPLETED_TRADES_POPUP,
    HIDE_EXPIRED_ORDERS_POPUP,
    HIDE_COMPLETED_TRADES_POPUP,
    SET_ORDER_POPUP_MODE,
    BEHALF_USERS_SUCCESS,
    BEHALF_USERS_FAIL,
    BEHALF_USERS_EXTRA_SUCCESS,
    BEHALF_USERS_EXTRA_FAIL,
    USERS_WITH_NOTIFICATIONS_SUCCESS,
    USERS_WITH_NOTIFICATIONS_FAIL
} from '../constants/action-types';

const initialState = {
    data: [],
    behalfUsers: [],
    behalfUsersExtra: [],
    freightTypes: [],
    error: '',
    fetching: false,
    type: '',
    isOrderPopupVisible: false,
    popupMode: '',
    formData: {},
    notificationUsers: [],
}

export default function app(state = initialState, action) {
    switch (action.type) {
        case ORDERS_REQUEST:
            return {
                ...state,
                fetching: true
            }
        case ORDERS_SUCCESS:
            return {
                ...state,
                fetching: false,
                data: action.payload,
                type: action.orderType
            }
        case ORDERS_FAIL:
            return {
                ...initialState,
                fetching: false,
                error: action.error || '',
                type: ''
            }
        case BEHALF_USERS_SUCCESS:
            return {
                ...state,
                fetching: false,
                behalfUsers: action.payload,
            }
        case BEHALF_USERS_FAIL:
            return {
                ...state,
                fetching: false,
                behalfUsers: [],
            }
        case BEHALF_USERS_EXTRA_SUCCESS:
            return {
                ...state,
                fetching: false,
                behalfUsersExtra: action.payload,
            }
        case BEHALF_USERS_EXTRA_FAIL:
            return {
                ...state,
                fetching: false,
                behalfUsersExtra: [],
            }
        case SHOW_ORDER_POPUP:
            return {
                ...state,
                isOrderPopupVisible: true,
                popupMode: action.popupMode,
                formData: action.formData,
            }
        case DUPLICATE_ORDER_POPUP:
            return {
                ...state,
                isOrderPopupVisible: true,
                popupMode: action.popupMode,
                formData: action.formData,
            }
        case HIDE_ORDER_POPUP:
            return {
                ...state,
                isOrderPopupVisible: false,
                popupMode: '',
                formData: {}
            }
        case SHOW_EXPIRED_ORDERS_POPUP:
            return {
                ...state,
                isExpiredOrdersPopupVisible: true,
            }
        case SHOW_COMPLETED_TRADES_POPUP:
            return {
                ...state,
                isCompletedTradesPopupVisible: true,
            }
        case HIDE_EXPIRED_ORDERS_POPUP:
            return {
                ...state,
                isExpiredOrdersPopupVisible: false,
            }
        case HIDE_COMPLETED_TRADES_POPUP:
            return {
                ...state,
                isCompletedTradesPopupVisible: false,
            }
        case SET_ORDER_POPUP_MODE:
            return {
                ...state,
                popupMode: action.mode,
            }
        case USERS_WITH_NOTIFICATIONS_SUCCESS: 
            return {
                ...state,
                notificationUsers: action.users
            }
        case USERS_WITH_NOTIFICATIONS_FAIL: 
            return {
                ...state,
                notificationUsers: []
            }
        default:
            return state;
  }


}



// WEBPACK FOOTER //
// ./source/reducers/orders.js